import { FC, ReactNode, createContext, useContext } from 'react';

import venueServiceStoreImpl from './VenueServiceStore';

const storeContext = createContext(venueServiceStoreImpl);

type Props = {
  children: ReactNode;
};

export const VenueServiceStoreProvider: FC<Props> = ({ children }) => {
  return (
    <storeContext.Provider value={venueServiceStoreImpl}>
      {children}
    </storeContext.Provider>
  );
};

export const useVenueServiceStore = () => useContext(storeContext);
